<template>
    <div class="advantages__container">
        <div class="advantages__icon-box">
            <img :src="image" alt="Icon">
        </div>
        <div class="advantages__text-content">
            <div class="advantages__headline" v-html="headline"></div>
            <div class="advantages__text" v-html="text"></div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            className: String,
            headline: String,
            image: String,
            text: String
        }
    }
</script>
